import GruposLista from '@/pages/produtos/grupos/GruposLista'

export default [
  {
    path: '/catalogo/grupos',
    name: 'ProdutosGrupos',
    component: GruposLista,
    meta: { permissao: 'grupos_produtos:acessar' }
  }
];
